import React from 'react';

import DataGrid from './DataGrid';
import { DataGridColDef } from './DataGrid/DataGrid';
import { PropElemScheduleResponse } from '../services/proposal';
import { toCurrency } from '../utils/utils';
import AccountingEntryModal from '../pages/Accounting/Components/AccountingEntryModal';

const COLUMNS: DataGridColDef<PropElemScheduleResponse>[] = [
  {
    comcode: 'IfrsSchedule.ctsorder',
    dataIndex: 'ctsorder',
    fixed: 'left',
    width: 80,
  },
  {
    comcode: 'IfrsSchedule.ctstype',
    dataIndex: 'ctstype',
    fixed: 'left',
    width: 100,
  },
  {
    comcode: 'IfrsSchedule.ctsduedate',
    dataIndex: 'ctsduedate',
    fixed: 'left',
    width: 100,
  },
  {
    align: 'right',
    comcode: 'IfrsSchedule.ctsstartamount',
    dataIndex: 'ctsstartamount',
    render: toCurrency,
    width: 100,
  },
  {
    align: 'right',
    comcode: 'IfrsSchedule.ctsamortizedamount',
    dataIndex: 'ctsamortizedamount',
    render: toCurrency,
    width: 100,
  },
  {
    align: 'right',
    comcode: 'IfrsSchedule.ctsinterestamount',
    dataIndex: 'ctsinterestamount',
    render: toCurrency,
    width: 100,
  },
  {
    align: 'right',
    comcode: 'IfrsSchedule.ctsrentalamount',
    dataIndex: 'ctsrentalamount',
    render: toCurrency,
    width: 100,
  },
  {
    align: 'right',
    comcode: 'IfrsSchedule.ctsoutstandingamount',
    dataIndex: 'ctsoutstandingamount',
    render: toCurrency,
    width: 100,
  },
  {
    comcode: 'IfrsSchedule.ctsstartdate',
    dataIndex: 'ctsstartdate',
    width: 100,
  },
  {
    comcode: 'IfrsSchedule.ctsenddate',
    dataIndex: 'ctsenddate',
    width: 100,
  },
  {
    comcode: 'IfrsSchedule.ctsstatus',
    dataIndex: 'ctsstatus',
    width: 100,
  },
  {
    comcode: 'IfrsSchedule.accountingdate',
    dataIndex: 'accountingdate',
    width: 100,
  },
  {
    comcode: 'IfrsSchedule.accountingreference',
    dataIndex: 'accountingreference',
    render: (accountingreference) => (
      <AccountingEntryModal accountingReference={accountingreference} />
    ),
    width: 200,
    fixed: 'right',
  },
];

export type IfrsScheduleTableProps = {
  financialSchedule: PropElemScheduleResponse[];
};

const IfrsScheduleTable = (props: IfrsScheduleTableProps) => {
  const { financialSchedule } = props;

  return (
    <DataGrid
      dataSource={financialSchedule}
      columns={COLUMNS}
      rowKey={(record) => record.ctsorder}
      scroll={{ x: 1000, y: 360 }}
      pagination={{ pageSize: 200 }}
    />
  );
};

export default IfrsScheduleTable;
